// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BlogCard_cardContainer__fuGq1 {
  display: flex;
  width: 100%;
  max-width: 100%;
  background-color: var(--white-color);
  border-radius: 12px;
  box-shadow: 0px 5px 25px #0000000d;
  position: relative;
  overflow: hidden;
}

.BlogCard_imageContainer__t-HIQ {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

.BlogCard_imageContainer__t-HIQ img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

.BlogCard_contentContainer__EOtRk {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 24px;
  gap: 16px;
  flex: 1 1;
}

.BlogCard_title__aeb5W {
  color: var(--text-color-v2);
  margin: 0;
  padding-right: 16px;
  word-wrap: break-word;
}

.BlogCard_date__tumH0 {
  color: var(--primary-color);
  margin: 0;
  min-height: 40px;
}

.BlogCard_detail__vvip3 {
  color: var(--black-color);
  min-height: 150px;
  text-align: left;
  padding-right: 30px;
}


@media (max-width: 768px) {
  .BlogCard_cardContainer__fuGq1 {
    flex-direction: column;
    align-items: center;
  }

  .BlogCard_imageContainer__t-HIQ {
    width: 100%;
    height: auto;
  }

  .BlogCard_contentContainer__EOtRk {
    width: 100%;
    padding: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/molecules/BlogCard/BlogCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,SAAO;AACT;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;AACrB;;;AAGA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":[".cardContainer {\n  display: flex;\n  width: 100%;\n  max-width: 100%;\n  background-color: var(--white-color);\n  border-radius: 12px;\n  box-shadow: 0px 5px 25px #0000000d;\n  position: relative;\n  overflow: hidden;\n}\n\n.imageContainer {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n.imageContainer img {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  max-width: 100%;\n  max-height: 100%;\n}\n\n.contentContainer {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  padding: 24px;\n  gap: 16px;\n  flex: 1;\n}\n\n.title {\n  color: var(--text-color-v2);\n  margin: 0;\n  padding-right: 16px;\n  word-wrap: break-word;\n}\n\n.date {\n  color: var(--primary-color);\n  margin: 0;\n  min-height: 40px;\n}\n\n.detail {\n  color: var(--black-color);\n  min-height: 150px;\n  text-align: left;\n  padding-right: 30px;\n}\n\n\n@media (max-width: 768px) {\n  .cardContainer {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .imageContainer {\n    width: 100%;\n    height: auto;\n  }\n\n  .contentContainer {\n    width: 100%;\n    padding: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cardContainer": `BlogCard_cardContainer__fuGq1`,
	"imageContainer": `BlogCard_imageContainer__t-HIQ`,
	"contentContainer": `BlogCard_contentContainer__EOtRk`,
	"title": `BlogCard_title__aeb5W`,
	"date": `BlogCard_date__tumH0`,
	"detail": `BlogCard_detail__vvip3`
};
export default ___CSS_LOADER_EXPORT___;
